<template>
  <card-seplag :titulo="nomeCard">
    <div class="p-col-12 p-component p-fieldset" style="margin-bottom: 1%">
      <div class="p-grid" style="padding-left: 1%">
        <div class="p-col-1 col-imagem">
          <i class="pi pi-user iconIdentificacaoForm"></i>
        </div>
        <div class="p-col-md-11 p-col-sm-12" style="margin-top: 2%">
          <p>
            <strong>Data da solicitação:</strong>
            {{ solicitacaoVerbaRec.dataSolicitacaoVerbaResc }}
          </p>
          <p>
            <strong>{{ dadosPessoa.nome }}</strong>
          </p>
          <p><strong>Matrícula:</strong> {{ dadosPessoa.matricula }}</p>
          <p><strong>CPF:</strong> {{ dadosPessoa.cpf }}</p>
        </div>
      </div>
    </div>
    <Rotulo nome="Email:" cols="12 4" requerido>
      <InputText
        type="text"
        id="descEmail"
        v-model="solicitacaoVerbaRec.descEmail"
        disabled
      />
    </Rotulo>
    <Rotulo nome="Contato com WhatsApp" cols="12 2" requerido>
      <InputMask
        id="descTelefoneWhatsapp"
        mask="(99)9 9999-9999"
        placeholder="(99)9 9999-9999"
        v-model="solicitacaoVerbaRec.descTelefoneWhatsapp"
        disabled
      />
    </Rotulo>
    <Rotulo nome="Contato" cols="12 2">
      <InputMask
        id="descTelefone"
        mask="(99)9 9999-9999"
        placeholder="(99)9 9999-9999"
        v-model="solicitacaoVerbaRec.descTelefone"
        disabled
      />
    </Rotulo>
    <Divider class="p-col-12" style="border: 1px solid #d5d5d5" />
    <h3 class="p-col-12">DADOS BANCÁRIOS PARA PAGAMENTO:</h3>
    <Rotulo nome="Banco:" cols="12 4" requerido>
      <InputText
        type="text"
        id="conta"
        v-model="dadosBancarios.banco"
        disabled
      />
    </Rotulo>
    <Rotulo nome="Agencia:" cols="12 4" requerido>
      <InputText
        type="text"
        id="agencia"
        v-model="dadosBancarios.agencia"
        disabled
      />
    </Rotulo>
    <Rotulo nome="Conta:" cols="12 4" requerido>
      <InputText
        type="text"
        id="conta"
        v-model="dadosBancarios.conta"
        disabled
      />
    </Rotulo>
    <Divider class="p-col-12" style="border: 1px solid #d5d5d5" />
    <div class="p-col-12 p-grid" style="padding-left: 1%">
      <div class="p-col-12 p-md-4">
        <Button
          type="button"
          icon="pi pi-book"
          label="Adicionar Processo"
          v-tooltip.top="'NovaSolicitação'"
          @click="novoProcesso()"
          :disabled="naoPodeEditar"
        />
      </div>
      <DataTable
        :value="solicitacaoVerbaRec.solicitacaoVerbaProcessoList"
        class="p-col-12 p-datatable-responsive"
      >
        <Column
          field="descProcesso"
          header="Processo"
          :bodyStyle="{ 'text-align': 'center' }"
          :headerStyle="{ textAlign: 'center', width: '15%' }"
        ></Column>
        <Column
          field="dataCitacao"
          header="Data Citação"
          :headerStyle="{ textAlign: 'center', width: '7%' }"
        ></Column>
        <Column field="flagRecebeuValor" header="RPV pago ou expedido?">
          <template #body="slotProps">
            {{ slotProps.data.flagRecebeuValor == "S" ? "Sim" : "Não" }}
          </template>
        </Column>
        <Column field="flagSuspenso" header="Processo suspenso?">
          <template #body="slotProps">
            {{ slotProps.data.flagSuspenso == "S" ? "Sim" : "Não" }}
          </template>
        </Column>
        <Column field="descObjetoAcao" header="Objeto da Acao"></Column>
        <Column field="anoVinculo" header="Ano/Vinculo">
          <template #body="slotProps">
            {{
              slotProps.data.anoVinculo && slotProps.data.anoVinculo.length > 0
                ? slotProps.data.anoVinculo.join(", ")
                : ""
            }}
          </template>
        </Column>
        <Column
          field="valrRecebido"
          header="Valor Recebido"
          :bodyStyle="{ 'text-align': 'center' }"
        >
          <template #body="slotProps">
            {{
              slotProps.data.valrRecebido
                ? slotProps.data.valrRecebido.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                : "Não Informado"
            }}
          </template>
        </Column>
        <Column
          header="Ação"
          :bodyStyle="{ 'text-align': 'center' }"
          :headerStyle="{ textAlign: 'center', width: '7%' }"
        >
          <template #body="slotProps">
            <Button
              type="button"
              icon="pi pi-pencil"
              class="p-button-warning"
              v-tooltip.top="'Editar'"
              @click="editarProcesso(slotProps.data)"
              :disabled="naoPodeEditar"
            />
            <Button
              type="button"
              icon="pi pi-trash"
              class="p-button-danger"
              v-tooltip.top="'Deletar'"
              style="margin-left: 2px"
              @click="deletarProcesso(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <Divider class="p-col-12" style="border: 1px solid #d5d5d5" />
    <Rotulo nome="Descrição Despacho" cols="12">
      <Textarea v-model="registro.descDespacho" rows="5" cols="30" />
    </Rotulo>
    <div class="p-col-12 p-grid" style="margin-top: 10px">
      <Rotulo nome="Valores Calculados" cols="12" requerido>
        <div style="display: flex">
          <div class="p-col-12 p-md-3">
            <Button
              type="button"
              icon="pi pi-dollar"
              label="Calcular Juros do Processo"
              v-tooltip.top="'Calcular Juros do Processo'"
              @click="calculaProcesso()"
              :disabled="naoPodeEditar"
            />
          </div>
          <div class="p-col-12 p-md-3">
            <Button
              type="button"
              icon="pi pi-calendar-plus"
              label="Editar Data Final de Calculo"
              class="p-button-warning"
              style="color: white"
              v-tooltip.top="'Editar Data Final de Calculo'"
              @click="abrirModalEditarDataFinal()"
              :disabled="naoPodeEditar"
            />
          </div>
        </div>
        <DataTable
          :value="solicitacaoVerbaRec.solicitacaoValorVinculoList"
          class="p-col-12 p-datatable-responsive"
          scrollHeight="flex"
          :scrollable="true"
          responsiveLayout="scroll"
          dataKey="idenSolicitacaoValorVinculo"
          style="max-height: 250px; overflow-y: auto"
        >
          <Column
            field="flagUtilizado"
            header=""
            :bodyStyle="'text-align:center'"
          >
            <template #header="">
              <Checkbox
                id="selecionarTudoBaseCalculo"
                inputId="selecionarTudoBaseCalculo"
                name="selecionarTudoBaseCalculo"
                :binary="true"
                v-model="selecionarTudoBaseCalculo"
                v-tooltip.top="'Selecionar Tudo'"
                @input="checkBoxAdicionarTudoListaValor"
              />
            </template>
            <template #body="slotProps">
              <Checkbox
                :id="slotProps.data.idenSolicitacaoValorVinculo"
                name="selecCalculo"
                :binary="true"
                falseValue="N"
                trueValue="S"
                v-model="slotProps.data.flagUtilizado"
                @input="checkBoxAlteradoListaValor"
              />
            </template>
          </Column>
          <Column
            field="descricaoAnoVinculo"
            header="Ano/Vinculo"
            :bodyStyle="'text-align:center'"
          ></Column>
          <Column
            field="gozo15Dias1Semestre"
            header="Gozo férias 1o semestre"
            :bodyStyle="'text-align:center'"
          ></Column>
          <Column
            field="dataInicialAdicionalFerias"
            header="Data Inicio Adic. Férias"
            :bodyStyle="'text-align:center'"
          ></Column>
          <Column
            field="dataInicialRescisao"
            header="Data Inicio Rescisão"
            :bodyStyle="'text-align:center'"
          ></Column>
          <Column
            field="dataFinal"
            header="Data Final Calculo"
            :bodyStyle="'text-align:center'"
          ></Column>
          <Column
            field="valorAdicionalFeriasEfetivo"
            header="Valor Adic. Férias 1º Semestre"
            :bodyStyle="'text-align:center'"
          >
            <template #body="slotProps">
              {{
                slotProps.data.valorAdicionalFeriasEfetivo
                  ? slotProps.data.valorAdicionalFeriasEfetivo.toLocaleString(
                      "pt-BR",
                      { style: "currency", currency: "BRL" }
                    )
                  : "R$ 0,00"
              }}
            </template>
          </Column>
          <Column
            field="valorRescisaoEfetivo"
            header="Valor Rescisão (férias + respectivo adic.)"
            :bodyStyle="'text-align:center'"
          >
            <template #body="slotProps">
              {{
                slotProps.data.valorRescisaoEfetivo
                  ? slotProps.data.valorRescisaoEfetivo.toLocaleString(
                      "pt-BR",
                      { style: "currency", currency: "BRL" }
                    )
                  : "R$ 0,00"
              }}
            </template>
          </Column>
          <Column
            field="valorTotalCorrigido"
            header="Valor Total Atualizado"
            :bodyStyle="'text-align:center'"
          >
            <template #body="slotProps">
              {{
                slotProps.data.valorTotalCorrigido != null
                  ? slotProps.data.valorTotalCorrigido.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  : "Não Calculado"
              }}
            </template>
          </Column>
          <Column
            field="descricaoMotivoAlteracaoValor"
            header="Desc. Motivo Alteração"
            :bodyStyle="'text-align:center'"
          >
            <template #body="slotProps">
              {{
                slotProps.data.descricaoMotivoAlteracaoValor
                  ? buscaMotivo(slotProps.data.descricaoMotivoAlteracaoValor)
                  : ""
              }}
            </template>
          </Column>
          <Column
            header="Ação"
            :bodyStyle="'text-align:center'"
            :headerStyle="'width: 7%;'"
          >
            <template #body="slotProps">
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-warning"
                v-tooltip.top="'Alterar Valores'"
                style="color: white"
                @click="editaValores(slotProps.data)"
                :disabled="naoPodeEditar"
              />
            </template>
          </Column>
        </DataTable>
      </Rotulo>
      <Rotulo nome="Valor extraído do SEAP:" cols="12 4">
        <InputNumber
          id="valorCalculado"
          v-model="valorTotalPadrao"
          mode="currency"
          currency="BRL"
          disabled
        />
      </Rotulo>

      <Rotulo nome="Valor final revisado:" cols="12 4">
        <InputNumber
          id="valorCalculadoFinal"
          v-model="valorCalculadoFinal"
          mode="currency"
          currency="BRL"
          disabled
        />
      </Rotulo>
    </div>
    <Divider class="p-col-12" style="border: 1px solid #d5d5d5" />
    <div class="p-col-12 p-md-6 divBotoesFinais">
      <Button
        label="Voltar"
        icon="pi pi-arrow-left"
        @click="voltarParaLista"
        class="p-button-text"
      />
      <Button
        label="Gravar"
        icon="pi pi-save"
        @click="gravarDespacho"
        style="margin-left: 2px"
      />
      <Button
        label="Voltar Revisão"
        icon="pi pi-send"
        class="p-button-warning"
        @click="enviarCriacao()"
        style="margin-left: 2px; color: white"
        v-if="this.solicitacaoVerbaRec.statAndamento == 'EM_REVISAO'"
      />
      <Button
        label="Indeferir"
        icon="pi pi-times"
        class="p-button-danger"
        @click="confirmarIndeferimento()"
        style="margin-left: 2px; color: white"
        v-if="this.solicitacaoVerbaRec.statAndamento == 'EM_REVISAO'"
      />
      <Button
        label="Finalizar"
        class="p-button-success"
        icon="pi pi-check"
        style="margin-left: 2px"
        v-if="this.solicitacaoVerbaRec.statAndamento == 'EM_REVISAO'"
        @click="confirmarFinalizacao()"
      />
    </div>

    <Dialog
      header="Editar Valor Calculado"
      :visible.sync="visualizarModalEditarValor"
      :containerStyle="{ width: '50vw' }"
      contentStyle="overflow-y: unset"
      :modal="true"
    >
      <div class="p-grid">
        <Rotulo nome="Ano/Vinculo:" cols="12 3">
          <InputText
            type="text"
            id="descricaoAnoVinculo"
            v-model="valorselecionado.descricaoAnoVinculo"
            disabled
          />
        </Rotulo>
        <Rotulo nome="Data final calculo:" cols="12 3">
          <InputMask
            id="dataFinal"
            mask="99/99/9999"
            v-model="valorselecionado.dataFinal"
            :disabled="naoPodeEditar"
          />
        </Rotulo>
        <Rotulo nome="Valor recisão:" cols="12 3">
          <InputText
            id="valorRescisaoEfetivo"
            v-model="valorselecionado.valorRescisaoEfetivo"
            @input="mascaraValor('valorRescisaoEfetivo')"
          />
        </Rotulo>
        <Rotulo nome="Valor do terço de ferias coletivas:" cols="12 3">
          <InputText
            id="valorAdicionalFeriasEfetivo"
            v-model="valorselecionado.valorAdicionalFeriasEfetivo"
            @input="mascaraValor('valorAdicionalFeriasEfetivo')"
          />
        </Rotulo>
        <Rotulo nome="Motivo alteração:" cols="12 3">
          <Dropdown
            v-model="valorselecionado.descricaoMotivoAlteracaoValor"
            :options="listaMotivo"
            optionLabel="name"
            optionValue="code"
            placeholder="Selecione..."
            filter
            showClear
          />
        </Rotulo>
      </div>
      <template #footer>
        <Button
          label="Resetar valores"
          icon="pi pi-pencil"
          @click="resetarValores(valorselecionado)"
          class="p-button-warning"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          @click="fecharModal"
          class="p-button-text"
        />
        <Button
          label="Salvar"
          icon="pi pi-save"
          @click="finalizaEdicaoValores"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      header="Editar Data Final de Calculo"
      :visible.sync="visualizarModalAdicionarCitacao"
      :containerStyle="{ width: '50vw' }"
      contentStyle="overflow-y: unset"
      :modal="true"
    >
      <div class="p-grid">
        <Rotulo nome="Função da Edição:" cols="12 3">
          <SelectButton
            v-model="registroDataFinal.funcao"
            :options="listaFuncaoDataFinal"
            optionLabel="name"
            optionValue="code"
          />
        </Rotulo>
        <Rotulo
          nome="Data Citação:"
          cols="12 3"
          v-if="registroDataFinal.funcao == 1"
        >
          <InputMask
            id="dataCitacao"
            mask="99/99/9999"
            v-model="registroDataFinal.novaData"
          />
        </Rotulo>
        <Divider class="p-col-12" />
        <Rotulo nome="Editar Valor:" cols="12 3">
          <SelectButton
            v-model="registroDataFinal.flagAlterarValores"
            :options="listaSimNao"
            optionLabel="name"
            optionValue="code"
          />
        </Rotulo>
        <Rotulo
          nome="Valor recisão:"
          cols="12 3"
          v-if="registroDataFinal.flagAlterarValores == true"
        >
          <InputText
            id="valorRescisaoEfetivo"
            v-model="registroDataFinal.valorRescisaoEfetivo"
            @input="mascaraValorEditaTadaFim('valorRescisaoEfetivo')"
          />
        </Rotulo>
        <Rotulo
          nome="Valor do terço de ferias coletivas:"
          cols="12 3"
          v-if="registroDataFinal.flagAlterarValores == true"
        >
          <InputText
            id="valorAdicionalFeriasEfetivo"
            v-model="registroDataFinal.valorAdicionalFeriasEfetivo"
            @input="mascaraValorEditaTadaFim('valorAdicionalFeriasEfetivo')"
          />
        </Rotulo>
        <Rotulo
          nome="Motivo alteração:"
          cols="12 3"
          v-if="registroDataFinal.flagAlterarValores == true"
        >
          <Dropdown
            v-model="registroDataFinal.descricaoMotivoAlteracaoValor"
            :options="listaMotivo"
            optionLabel="name"
            optionValue="code"
            placeholder="Selecione..."
            filter
            showClear
          />
        </Rotulo>
        <Divider class="p-col-12" />
        <div class="p-col-12">
          <div style="display: flex; align-items: center">
            <Checkbox
              id="selecionarTudoProcesso"
              name="selecionarTudoProcesso"
              :binary="true"
              v-model="selecionarTudoDataFinal"
              style="margin-right: 2px; margin-left: 5px"
              v-tooltip.top="'Selecionar Tudo'"
              @input="todosAnoVinculoDataFinal"
            />
            <label>Ano/Vinculo:</label>
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="valorVinculo of solicitacaoVerbaRec.solicitacaoValorVinculoList"
              :key="valorVinculo.descricaoAnoVinculo"
              style="width: 10%; display: flex; margin: 5px"
            >
              <Checkbox
                :id="valorVinculo.descricaoAnoVinculo"
                name="valorVinculo"
                :value="valorVinculo.descricaoAnoVinculo"
                v-model="registroDataFinal.anoVinculo"
                @input="verificaTodosAnoVinculoDataFinal"
              />
              <label
                :for="valorVinculo.descricaoAnoVinculo"
                style="margin-left: 2px"
                >{{ valorVinculo.descricaoAnoVinculo }}</label
              >
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          @click="fecharModal"
          class="p-button-text"
        />
        <Button
          label="Salvar"
          icon="pi pi-check"
          @click="editarDataFinalCalculo"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Novo Processo"
      :visible.sync="visualizarModalProcesso"
      :containerStyle="{ width: '50vw' }"
      contentStyle="overflow-y: unset"
      :modal="true"
    >
      <div class="p-grid">
        <Rotulo nome="Numero do Processo:" cols="12 3">
          <InputText
            id="descProcesso"
            placeholder="XXXXXX-XX.ANO.8.11.XXXX"
            v-model="processo.descProcesso"
            :disabled="naoPodeEditar"
            @input="applyMask"
          />
        </Rotulo>
        <Rotulo nome="Data Citação:" cols="12 3">
          <InputMask
            id="dataCitacao"
            mask="99/99/9999"
            v-model="processo.dataCitacao"
            :disabled="naoPodeEditar"
          />
        </Rotulo>
        <Rotulo nome="Objeto da ação:" cols="12 3">
          <Dropdown
            v-model="processo.descObjetoAcao"
            :options="listaObjetoAcao"
            optionLabel="name"
            optionValue="code"
            placeholder="Selecione..."
            filter
            showClear
          />
        </Rotulo>
        <Rotulo nome="Observação:" cols="12 3">
          <InputText
            id="observacao"
            v-model="processo.observacao"
            :disabled="naoPodeEditar"
          />
        </Rotulo>
        <Divider class="p-col-12" />
        <div class="p-col-12">
          <div style="display: flex; align-items: center">
            <Checkbox
              id="selecionarTudoProcesso"
              name="selecionarTudoProcesso"
              :binary="true"
              v-model="selecionarTudoProcesso"
              style="margin-right: 2px; margin-left: 5px"
              v-tooltip.top="'Selecionar Tudo'"
              @input="todosAnoVinculoProcesso"
            />
            <label>Ano/Vinculo:</label>
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="valorVinculo of solicitacaoVerbaRec.solicitacaoValorVinculoList"
              :key="valorVinculo.descricaoAnoVinculo"
              style="width: 10%; display: flex; margin: 5px"
            >
              <Checkbox
                :id="valorVinculo.descricaoAnoVinculo"
                name="valorVinculo"
                :value="valorVinculo.descricaoAnoVinculo"
                v-model="processo.anoVinculo"
                @input="verificaTodosAnoVinculoProcesso"
              />
              <label
                :for="valorVinculo.descricaoAnoVinculo"
                style="margin-left: 2px"
                >{{ valorVinculo.descricaoAnoVinculo }}</label
              >
            </div>
          </div>
        </div>
        <Divider class="p-col-12" />
        <Rotulo nome="Há expedição ou pagamento de RPV?" cols="12 6">
          <div class="divRadioButton">
            <div class="field-radiobutton">
              <RadioButton
                id="flagRecebeuValor"
                name="flagRecebeuValor"
                value="S"
                v-model="processo.flagRecebeuValor"
                :disabled="naoPodeEditar"
              />
              <span for="flagRecebeuValor" style="margin-left: 2px">Sim</span>
            </div>
            <div class="field-radiobutton">
              <RadioButton
                id="flagRecebeuValor"
                name="flagRecebeuValor"
                value="N"
                v-model="processo.flagRecebeuValor"
                style="margin-left: 2px"
                :disabled="naoPodeEditar"
              />
              <span for="flagRecebeuValor" style="margin-left: 2px">Não</span>
            </div>
          </div>
        </Rotulo>
        <Rotulo
          nome="Valor a Receber ou já Recebido:"
          cols="12 3"
          v-if="processo.flagRecebeuValor == 'S'"
        >
          <InputNumber
            id="valrRecebidoProcesso"
            v-model="processo.valrRecebido"
            mode="currency"
            currency="BRL"
          />
        </Rotulo>
        <Divider class="p-col-12" />
        <Rotulo nome="O processo foi suspenso?" cols="12 6">
          <div class="divRadioButton">
            <div class="field-radiobutton">
              <RadioButton
                id="flagSuspenso"
                name="flagSuspenso"
                value="S"
                v-model="processo.flagSuspenso"
                :disabled="naoPodeEditar"
              />
              <span for="flagRecebeuValor" style="margin-left: 2px">Sim</span>
            </div>
            <div class="field-radiobutton">
              <RadioButton
                id="flagSuspenso"
                name="flagSuspenso"
                value="N"
                v-model="processo.flagSuspenso"
                style="margin-left: 2px"
                :disabled="naoPodeEditar"
              />
              <span for="flagRecebeuValor" style="margin-left: 2px">Não</span>
            </div>
          </div>
        </Rotulo>
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          @click="fecharModal"
          class="p-button-text"
        />
        <Button
          label="Salvar"
          icon="pi pi-check"
          @click="cadastrarNovoProcesso"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Finalizar proposta"
      :visible.sync="visualizarModalConfirmacaoRevisao"
      :containerStyle="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span>Enviar para revisão? </span>
      </div>
      <template #footer>
        <Button
          label="Não"
          icon="pi pi-times"
          @click="fecharRevisao()"
          class="p-button-text"
        />
        <Button
          label="Sim"
          icon="pi pi-check"
          @click="enviarRevisao()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Finalizar proposta"
      :visible.sync="visualizarModalEnviarProsta"
      :containerStyle="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span>Enviar proposta ao servidor?</span>
      </div>
      <template #footer>
        <Button
          label="Não"
          icon="pi pi-times"
          @click="fecharModal()"
          class="p-button-text"
        />
        <Button
          label="Sim"
          icon="pi pi-check"
          @click="finalizarDespacho()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Indeferir proposta"
      :visible.sync="visualizarModalIndeferir"
      :containerStyle="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span>Indeferir requerimento do servidor?</span>
      </div>
      <template #footer>
        <Button
          label="Não"
          icon="pi pi-times"
          @click="fecharModal()"
          class="p-button-text"
        />
        <Button
          label="Sim"
          icon="pi pi-check"
          @click="indeferirDespacho()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
const getNovoForm = () => {
  return {
    descDespacho: "",
    solicitacaoVerbaRescisoria: null,
    solicitacaoDespachoPropostaList: [],
    valorTotalDevido: 0,
  };
};
const getNovoValor = () => {
  return {
    descricaoMotivoAlteracaoValor: null,
    descricaoAnoVinculo: "",
    valorTotalDevido: 0,
    valorTotalEfetivo: 0,
    valorTotalCorrigido: 0,
    umTercoSobre15DiasFerias: 0,
    dataInicioCalculo: null,
    dataFimCalculo: null,
    dataInicioUmterFerias: null,
    dataInicioRecisao: null,
  };
};
const getNovoProcesso = () => {
  return {
    idenSolicitacaoVerbaProces: null,
    descProcesso: null,
    flagRecebeuValor: null,
    flagSuspenso: null,
    valrRecebido: null,
    statProcesso: null,
    descObjetoAcao: null,
    anoVinculo: [],
    dataFinal: "",
    observacao: "",
    flagOrigem: 2,
    code: 1,
  };
};
const getEditarDataFinalCalculo = () => {
  return {
    funcao: 1,
    anoVinculo: [],
    valorRescisaoEfetivo: 0,
    valorAdicionalFeriasEfetivo: 0,
    descricaoMotivoAlteracaoValor: null,
    flagAlterarValores: false,
    novaData: "",
  };
};
export default {
  name: "solicitaVerbaDespacho",
  components: { CardSeplag, Rotulo },
  data() {
    return {
      modo: "NOVO",
      naoPodeEditar: false,
      visualizarModalEditarValor: false,
      visualizarModalProcesso: false,
      visualizarModalAceito: false,
      visualizarModalConfirmacaoRevisao: false,
      visualizarModalEnviarProsta: false,
      visualizarModalAdicionarCitacao: false,
      visualizarModalIndeferir: false,
      selecionarTudoProcesso: false,
      selecionarTudoDataFinal: false,
      selecionarTudoBaseCalculo: false,
      idenSolicitacao: null,
      idenVinculo: null,
      valorTotalPadrao: 0,
      valorCalculado: 0,
      valorCalculadoFinal: 0,
      listaValorCalculado: [],
      nomeCard: "Análise de solicitação de verba indenizatória",
      registro: getNovoForm(),
      valorselecionado: getNovoValor(),
      processo: getNovoProcesso(),
      registroDataFinal: getEditarDataFinalCalculo(),
      dadosPessoa: {
        matricula: null,
        vinculo: null,
        cpf: null,
        nome: null,
        cpfFormatado: null,
      },
      solicitacaoVerbaRec: {
        idenSolicitacaoVerbaResc: null,
        descEmail: "",
        descTelefoneWhatsapp: "",
        flagPossuiProcesso: null,
        dataSolicitacaoVerbaResc: null,
        solicitacaoVerbaProcessoList: [],
      },
      listaMotivo: [
        { code: "PRESCRICAO", name: "Prescrição" },
        { code: "COISA_JULGADA", name: "Coisa julgada" },
        { code: "EXPE_PRECATORIO_RPV", name: "Expedição de Precatório/RPV" },
        { code: "VALOR_DIVERGENTE", name: "Outro(Descrito na Descrição)" },
      ],
      listaObjetoAcao: [
        { code: "FERIAS", name: "Férias" },
        {
          code: "FERIAS_ADICIONAL_FERIAS",
          name: "Férias + Adicional de Férias",
        },
        { code: "FERIAS_FGTS", name: "Férias + FGTS" },
      ],
      dadosBancarios: {
        agencia: "",
        conta: "",
        banco: "",
      },
      listaFuncaoDataFinal: [
        { name: "Adicionar", code: 1 },
        { name: "Apagar", code: 0 },
      ],
      listaSimNao: [
        { name: "Sim", code: true },
        { name: "Não", code: false },
      ],
    };
  },
  methods: {
    carregarDados() {
      let query = this.$route.query;
      if (query.id) {
        this.idenSolicitacao = query.id;
        this.$http
          .get(`${baseApiUrl}/solicitacoes-verba-rescisoria/${query.id}`)
          .then((res) => {
            if (res.data.solicitacaoVerbaProcessoList.length > 0) {
              let listaProcesso = res.data.solicitacaoVerbaProcessoList.map(
                function (process, indice) {
                  return {
                    ...process,
                    code: indice,
                    anoVinculo:
                      process.descricaoAnoVinculo &&
                      process.descricaoAnoVinculo.length > 0
                        ? process.descricaoAnoVinculo.split(";")
                        : [],
                  };
                }
              );
              let listaVinculo = res.data.solicitacaoValorVinculoList.filter(
                function (elemento) {
                  let anoVinculo = elemento.descricaoAnoVinculo.split("/");
                  //console.log(anoVinculo[0]);
                  return parseInt(anoVinculo[0]) >= 2015;
                }
              );
              listaVinculo.sort((a, b) => {
                const [anoA, numVinculoA] = a.descricaoAnoVinculo
                  .split("/")
                  .map(Number);
                const [anoB, numVinculoB] = b.descricaoAnoVinculo
                  .split("/")
                  .map(Number);

                // Ordena primeiro pelo ano e depois pelo numVinculo
                if (anoA !== anoB) {
                  return anoA - anoB;
                } else {
                  return numVinculoA - numVinculoB;
                }
              });
              this.solicitacaoVerbaRec = {
                ...res.data,
                solicitacaoVerbaProcessoList: listaProcesso,
                solicitacaoValorVinculoList: listaVinculo,
              };
            } else {
              let listaVinculo = res.data.solicitacaoValorVinculoList.filter(
                function (elemento) {
                  let anoVinculo = elemento.descricaoAnoVinculo.split("/");
                  return parseInt(anoVinculo[0]) >= 2015;
                }
              );

              listaVinculo.sort((a, b) => {
                const [anoA, numVinculoA] = a.descricaoAnoVinculo
                  .split("/")
                  .map(Number);
                const [anoB, numVinculoB] = b.descricaoAnoVinculo
                  .split("/")
                  .map(Number);

                // Ordena primeiro pelo ano e depois pelo numVinculo
                if (anoA !== anoB) {
                  return anoA - anoB;
                } else {
                  return numVinculoA - numVinculoB;
                }
              });
              this.solicitacaoVerbaRec = {
                ...res.data,
                solicitacaoValorVinculoList: listaVinculo,
              };
            }

            if (res.data.solicitacaoVerbaProcessoList.length > 0) {
              this.solicitacaoVerbaRec.flagPossuiProcesso = "1";
            } else {
              this.solicitacaoVerbaRec.flagPossuiProcesso = "0";
            }

            this.dadosPessoa = {
              matricula: res.data.numrMatricula,
              cpf: res.data.cpf,
              nome: res.data.nomeSolicitante,
            };

            this.listaValorCalculado = [
              ...res.data.solicitacaoValorVinculoList,
            ];

            let valorInicial = 0;
            let valorRevisado = 0;
            let contador = 0;
            for (
              let i = 0;
              i < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
              i++
            ) {
              if (
                this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i] &&
                this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                  .flagUtilizado == "S"
              ) {
                contador = contador + 1;
                if (
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i] &&
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                    .valorTotalCorrigido != null
                ) {
                  valorRevisado =
                    valorRevisado +
                    this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                      .valorTotalCorrigido;
                } else {
                  valorRevisado =
                    valorRevisado +
                    this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                      .valorRescisaoEfetivo +
                    this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                      .valorAdicionalFeriasEfetivo;
                }
                valorInicial =
                  valorInicial +
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                    .valorRescisaoEfetivo +
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                    .valorAdicionalFeriasEfetivo;
              }
            }
            this.valorCalculadoFinal = valorRevisado;
            this.valorCalculado = valorInicial;

            if (
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length ==
              contador
            ) {
              this.selecionarTudoBaseCalculo = true;
            } else {
              this.selecionarTudoBaseCalculo = false;
            }

            if (res.data.solicitacaoDespachoList.length > 0) {
              this.registro = res.data.solicitacaoDespachoList[0];
            }

            this.$http
              .get(`${baseApiUrl}/dados-bancarios/${res.data.numrMatricula}`)
              .then((res2) => {
                this.dadosBancarios = res2.data;
              });

            this.$http
              .get(
                `${baseApiUrl}/valores-vinculo/valor-total-padrao/${this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc}`
              )
              .then((res2) => {
                this.valorTotalPadrao = res2.data;
              });
          });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Não é permitido Acesso sem Solicitação selecionada.",
          life: 3000,
        });
      }
    },
    resetarValores(valorVinculo) {
      valorVinculo.valorRescisaoEfetivo = valorVinculo.valorRescisao;
      valorVinculo.valorAdicionalFeriasEfetivo =
        valorVinculo.valorAdicionalFerias;
    },
    calculaProcesso() {
      for (
        let j = 0;
        j < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
        j++
      ) {
        if (
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j]
            .flagUtilizado == "N"
        ) {
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
            j
          ].valorTotalCorrigido = 0;
        }
      }
      this.$http
        .put(
          `${baseApiUrl}/valores-vinculo/calcular-valor-total-corrigido`,
          JSON.stringify(this.solicitacaoVerbaRec.solicitacaoValorVinculoList)
        )
        .then((res) => {
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList = res.data;
          let valorSEAP = 0;
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].flagUtilizado == "S") {
              valorSEAP = valorSEAP + res.data[i].valorTotalCorrigido;
            }
          }
          this.valorCalculadoFinal = valorSEAP;
          this.$toast.add({
            severity: "success",
            summary: "Calculo efetuado com Sucesso.",
            life: 3000,
          });
        });
    },
    todosAnoVinculoProcesso() {
      if (this.selecionarTudoProcesso) {
        this.processo.anoVinculo = [];
        for (
          let i = 0;
          i < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
          i++
        ) {
          this.processo.anoVinculo.push(
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .descricaoAnoVinculo
          );
        }
      } else {
        this.processo.anoVinculo = [];
      }
    },
    verificaTodosAnoVinculoProcesso() {
      if (this.selecionarTudoProcesso) {
        this.selecionarTudoProcesso = false;
      }
      if (
        this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length ==
        this.processo.anoVinculo.length
      ) {
        this.selecionarTudoProcesso = true;
      }
    },
    todosAnoVinculoDataFinal() {
      if (this.selecionarTudoDataFinal) {
        this.registroDataFinal.anoVinculo = [];
        for (
          let i = 0;
          i < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
          i++
        ) {
          this.registroDataFinal.anoVinculo.push(
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .descricaoAnoVinculo
          );
        }
      } else {
        this.registroDataFinal.anoVinculo = [];
      }
    },
    verificaTodosAnoVinculoDataFinal() {
      if (this.selecionarTudoDataFinal) {
        this.selecionarTudoDataFinal = false;
      }
      if (
        this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length ==
        this.registroDataFinal.anoVinculo.length
      ) {
        this.selecionarTudoDataFinal = true;
      }
    },
    checkBoxAlteradoListaValor() {
      let valorInicial = 0;
      let valorRevisado = 0;
      let contador = 0;
      for (
        let i = 0;
        i < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
        i++
      ) {
        if (
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i] &&
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
            .flagUtilizado == "S"
        ) {
          contador = contador + 1;
          if (
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i] &&
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .valorTotalCorrigido != null
          ) {
            valorRevisado =
              valorRevisado +
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                .valorTotalCorrigido;
          } else {
            valorRevisado =
              valorRevisado +
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                .valorRescisaoEfetivo +
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                .valorAdicionalFeriasEfetivo;
          }
          valorInicial =
            valorInicial +
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .valorRescisaoEfetivo +
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .valorAdicionalFeriasEfetivo;
        }
      }
      this.valorCalculadoFinal = valorRevisado;
      this.valorCalculado = valorInicial;
      if (
        this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length == contador
      ) {
        this.selecionarTudoBaseCalculo = true;
      } else {
        this.selecionarTudoBaseCalculo = false;
      }
    },
    checkBoxAdicionarTudoListaValor() {
      let valorInicial = 0;
      let valorRevisado = 0;
      for (
        let i = 0;
        i < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
        i++
      ) {
        if (this.selecionarTudoBaseCalculo == true) {
          if (
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i] &&
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .valorTotalCorrigido != null
          ) {
            valorRevisado =
              valorRevisado +
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                .valorTotalCorrigido;
          } else {
            valorRevisado =
              valorRevisado +
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                .valorRescisaoEfetivo +
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
                .valorAdicionalFeriasEfetivo;
          }
          valorInicial =
            valorInicial +
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .valorRescisaoEfetivo +
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[i]
              .valorAdicionalFeriasEfetivo;
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
            i
          ].flagUtilizado = "S";
        } else {
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
            i
          ].flagUtilizado = "N";
        }
      }
      this.valorCalculadoFinal = valorRevisado;
      this.valorCalculado = valorInicial;
    },
    voltarParaLista() {
      this.$router.push({ name: "solicitaVerbaProcurador" });
    },
    fecharModal() {
      this.visualizarModalAceito = false;
      this.visualizarModalEditarValor = false;
      this.visualizarModalProcesso = false;
      this.visualizarModalConfirmacaoRevisao = false;
      this.visualizarModalEnviarProsta = false;
      this.visualizarModalAdicionarCitacao = false;
      this.visualizarModalIndeferir = false;
    },
    abrirModalEditarDataFinal() {
      this.registroDataFinal = getEditarDataFinalCalculo();
      this.visualizarModalAdicionarCitacao = true;
      this.selecionarTudoDataFinal = false;
    },
    editarDataFinalCalculo() {
      const regex = /^[-+]?(\d+(\.\d*)?|Infinity)$/;
      if (this.registroDataFinal.valorRescisaoEfetivo == null) {
        this.registroDataFinal.valorRescisaoEfetivo = 0;
      }
      if (regex.test(this.registroDataFinal.valorRescisaoEfetivo)) {
        this.registroDataFinal.valorRescisaoEfetivo = Number(
          this.registroDataFinal.valorRescisaoEfetivo
        );
      }
      if (this.registroDataFinal.valorAdicionalFeriasEfetivo == null) {
        this.registroDataFinal.valorAdicionalFeriasEfetivo = 0;
      }
      if (regex.test(this.registroDataFinal.valorAdicionalFeriasEfetivo)) {
        this.registroDataFinal.valorAdicionalFeriasEfetivo = Number(
          this.registroDataFinal.valorAdicionalFeriasEfetivo
        );
      }
      if (this.registroDataFinal.funcao == 1) {
        if (this.registroDataFinal.anoVinculo.length > 0) {
          for (let i = 0; i < this.registroDataFinal.anoVinculo.length; i++) {
            for (
              let j = 0;
              j < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
              j++
            ) {
              if (
                this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j]
                  .descricaoAnoVinculo == this.registroDataFinal.anoVinculo[i]
              ) {
                this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                  j
                ].dataFinal = this.registroDataFinal.novaData;
                if (this.registroDataFinal.flagAlterarValores == true) {
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                    j
                  ].descricaoMotivoAlteracaoValor =
                    this.registroDataFinal.descricaoMotivoAlteracaoValor;
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                    j
                  ].valorRescisaoEfetivo =
                    this.registroDataFinal.valorRescisaoEfetivo;
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                    j
                  ].valorAdicionalFeriasEfetivo =
                    this.registroDataFinal.valorAdicionalFeriasEfetivo;
                }
                break;
              }
            }
          }
        }
      } else {
        if (this.registroDataFinal.anoVinculo.length > 0) {
          for (let i = 0; i < this.registroDataFinal.anoVinculo.length; i++) {
            for (
              let j = 0;
              j < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
              j++
            ) {
              if (
                this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j]
                  .descricaoAnoVinculo == this.registroDataFinal.anoVinculo[i]
              ) {
                this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                  j
                ].dataFinal = "";
                if (this.registroDataFinal.flagAlterarValores == true) {
                  this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                    j
                  ].descricaoMotivoAlteracaoValor = "";
                }
                break;
              }
            }
          }
        }
      }
      this.checkBoxAlteradoListaValor();
      this.fecharModal();
    },
    novoProcesso() {
      this.modo = "NOVO";
      this.selecionarTudoProcesso = false;
      this.processo = getNovoProcesso();
      if (this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.length > 0) {
        this.processo.code =
          this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.length + 1;
      }
      this.visualizarModalProcesso = true;
    },
    cadastrarNovoProcesso() {
      if (this.validarData()) {
        if (this.modo == "NOVO") {
          if (this.processo.flagRecebeuValor == "N") {
            this.processo.valrRecebido = null;
          }
          this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.push(
            this.processo
          );
        } else {
          this.processo.anoVinculo.sort();
          for (
            let i = 0;
            i < this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.length;
            i++
          ) {
            if (
              this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList[i].code ==
              this.processo.code
            ) {
              this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList[i] = {
                ...this.processo,
              };
              break;
            }
          }
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Data de Citação invalida.",
          life: 3000,
        });

        return;
      }
      this.fecharModal();
    },
    editarProcesso(data) {
      this.modo = "EDITAR";
      this.processo = { ...data };
      this.selecionarTudoProcesso =
        data.anoVinculo.length ==
        this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
      this.visualizarModalProcesso = true;
      this.applyMask();
    },
    deletarProcesso(processo) {
      this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList =
        this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.filter(
          (element) => {
            return element.code != processo.code;
          }
        );
      this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList =
        this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.map(function (
          element,
          indice
        ) {
          return {
            ...element,
            code: indice,
          };
        });
    },
    editaValores(data) {
      this.valorselecionado = { ...data };
      this.visualizarModalEditarValor = true;
    },
    finalizaEdicaoValores() {
      const regex = /^[-+]?(\d+(\.\d*)?|Infinity)$/;
      if (this.valorselecionado.valorRescisaoEfetivo == null) {
        this.valorselecionado.valorRescisaoEfetivo = 0;
      }

      if (regex.test(this.valorselecionado.valorRescisaoEfetivo)) {
        this.valorselecionado.valorRescisaoEfetivo = Number(
          this.valorselecionado.valorRescisaoEfetivo
        );
      }
      if (this.valorselecionado.valorAdicionalFeriasEfetivo == null) {
        this.valorselecionado.valorAdicionalFeriasEfetivo = 0;
      }

      if (regex.test(this.valorselecionado.valorAdicionalFeriasEfetivo)) {
        this.valorselecionado.valorAdicionalFeriasEfetivo = Number(
          this.valorselecionado.valorAdicionalFeriasEfetivo
        );
      }
      let valorInicial = 0;
      for (
        let j = 0;
        j < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
        j++
      ) {
        if (
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j]
            .descricaoAnoVinculo == this.valorselecionado.descricaoAnoVinculo
        ) {
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
            j
          ].valorRescisaoEfetivo = this.valorselecionado.valorRescisaoEfetivo;
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
            j
          ].valorAdicionalFeriasEfetivo =
            this.valorselecionado.valorAdicionalFeriasEfetivo;
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
            j
          ].descricaoMotivoAlteracaoValor =
            this.valorselecionado.descricaoMotivoAlteracaoValor;
          this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j].dataFinal =
            this.valorselecionado.dataFinal;
          break;
        }
      }
      this.valorCalculadoFinal = valorInicial;
      this.checkBoxAlteradoListaValor();
      this.fecharModal();
    },
    gravarDespacho() {
      for (let i = 0; i < this.listaValorCalculado.length; i++) {
        for (
          let j = 0;
          j < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
          j++
        ) {
          if (
            this.listaValorCalculado[i].descricaoAnoVinculo ==
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j]
              .descricaoAnoVinculo
          ) {
            this.listaValorCalculado[i].descricaoAnoVinculo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].descricaoAnoVinculo;
            this.listaValorCalculado[i].valorRescisaoEfetivo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorRescisaoEfetivo;
            this.listaValorCalculado[i].valorAdicionalFeriasEfetivo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorAdicionalFeriasEfetivo;
            this.listaValorCalculado[i].valorTotalCorrigido =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorTotalCorrigido;
            this.listaValorCalculado[i].descricaoMotivoAlteracaoValor =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].descricaoMotivoAlteracaoValor;
            this.listaValorCalculado[i].dataFinal =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j].dataFinal;
            break;
          }
        }
      }
      let bodyRequest = {
        idenSolicitacaoVerbaRescisoria: this.solicitacaoVerbaRec
          .idenSolicitacaoVerbaResc
          ? this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc
          : this.solicitacaoVerbaRec.idenSolicitacaoVerbaRescisoria,
        solicitacaoDespacho: this.registro,
        solicitacaoVerbaProcessoList:
          this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.map(function (
            elemento
          ) {
            return {
              ...elemento,
              descricaoAnoVinculo:
                elemento.anoVinculo.length > 0
                  ? elemento.anoVinculo.join(";")
                  : "",
            };
          }),
        solicitacaoValorVinculoList: this.listaValorCalculado,
      };
      this.$http
        .post(`${baseApiUrl}/despachos/gravar`, JSON.stringify(bodyRequest))
        .then((res) => {
          this.$toast.add({
            severity: "success",
            summary:
              "Despacho Salvo com sucesso. Porfavor Aguarde o tramite do processo.",
            life: 3000,
          });
          if (res.data.solicitacaoVerbaProcessoList.length > 0) {
            let listaProcesso = res.data.solicitacaoVerbaProcessoList.map(
              function (process) {
                return {
                  ...process,
                  anoVinculo:
                    process.descricaoAnoVinculo.length > 0
                      ? process.descricaoAnoVinculo.split(";")
                      : [],
                };
              }
            );
            let listaVinculo = res.data.solicitacaoValorVinculoList.filter(
              function (elemento) {
                let anoVinculo = elemento.descricaoAnoVinculo.split("/");
                return parseInt(anoVinculo[0]) >= 2015;
              }
            );

            this.solicitacaoVerbaRec = {
              ...this.solicitacaoVerbaRec,
              statAndamento: res.data.statusAndamento,
              solicitacaoVerbaProcessoList: listaProcesso,
              solicitacaoValorVinculoList: listaVinculo,
            };
          } else {
            let listaVinculo = res.data.solicitacaoValorVinculoList.filter(
              function (elemento) {
                let anoVinculo = elemento.descricaoAnoVinculo.split("/");
                return parseInt(anoVinculo[0]) >= 2015;
              }
            );
            this.solicitacaoVerbaRec = {
              ...this.solicitacaoVerbaRec,
              statAndamento: res.data.statusAndamento,
              solicitacaoValorVinculoList: listaVinculo,
            };
          }
          this.registro = res.data.solicitacaoDespacho;

          if (res.data.statusAndamento == "EM_ANALISE") {
            this.confirmarRevisao();
          }
        });
    },

    finalizarDespacho() {
      for (let i = 0; i < this.listaValorCalculado.length; i++) {
        for (
          let j = 0;
          j < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
          j++
        ) {
          if (
            this.listaValorCalculado[i].descricaoAnoVinculo ==
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j]
              .descricaoAnoVinculo
          ) {
            this.listaValorCalculado[i].descricaoAnoVinculo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].descricaoAnoVinculo;
            this.listaValorCalculado[i].valorRescisaoEfetivo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorRescisaoEfetivo;
            this.listaValorCalculado[i].valorAdicionalFeriasEfetivo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorAdicionalFeriasEfetivo;
            this.listaValorCalculado[i].valorTotalCorrigido =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorTotalCorrigido;
            this.listaValorCalculado[i].descricaoMotivoAlteracaoValor =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].descricaoMotivoAlteracaoValor;
            this.listaValorCalculado[i].dataFinal =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j].dataFinal;
            break;
          }
        }
      }
      let bodyRequest = {
        idenSolicitacaoVerbaRescisoria: this.solicitacaoVerbaRec
          .idenSolicitacaoVerbaResc
          ? this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc
          : this.solicitacaoVerbaRec.idenSolicitacaoVerbaRescisoria,
        solicitacaoDespacho: this.registro,
        solicitacaoVerbaProcessoList:
          this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.map(function (
            elemento
          ) {
            return {
              ...elemento,
              descricaoAnoVinculo:
                elemento.anoVinculo.length > 0
                  ? elemento.anoVinculo.join(";")
                  : "",
            };
          }),
        solicitacaoValorVinculoList: this.listaValorCalculado,
      };
      this.$http
        .post(`${baseApiUrl}/despachos/finalizar`, JSON.stringify(bodyRequest))
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Despacho Enviado com sucesso.",
            life: 3000,
          });
          this.voltarParaLista();
        });
    },
    indeferirDespacho() {
      for (let i = 0; i < this.listaValorCalculado.length; i++) {
        for (
          let j = 0;
          j < this.solicitacaoVerbaRec.solicitacaoValorVinculoList.length;
          j++
        ) {
          if (
            this.listaValorCalculado[i].descricaoAnoVinculo ==
            this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j]
              .descricaoAnoVinculo
          ) {
            this.listaValorCalculado[i].descricaoAnoVinculo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].descricaoAnoVinculo;
            this.listaValorCalculado[i].valorRescisaoEfetivo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorRescisaoEfetivo;
            this.listaValorCalculado[i].valorAdicionalFeriasEfetivo =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorAdicionalFeriasEfetivo;
            this.listaValorCalculado[i].valorTotalCorrigido =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].valorTotalCorrigido;
            this.listaValorCalculado[i].descricaoMotivoAlteracaoValor =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[
                j
              ].descricaoMotivoAlteracaoValor;
            this.listaValorCalculado[i].dataFinal =
              this.solicitacaoVerbaRec.solicitacaoValorVinculoList[j].dataFinal;
            break;
          }
        }
      }
      let bodyRequest = {
        idenSolicitacaoVerbaRescisoria: this.solicitacaoVerbaRec
          .idenSolicitacaoVerbaResc
          ? this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc
          : this.solicitacaoVerbaRec.idenSolicitacaoVerbaRescisoria,
        solicitacaoDespacho: this.registro,
        solicitacaoVerbaProcessoList:
          this.solicitacaoVerbaRec.solicitacaoVerbaProcessoList.map(function (
            elemento
          ) {
            return {
              ...elemento,
              descricaoAnoVinculo:
                elemento.anoVinculo.length > 0
                  ? elemento.anoVinculo.join(";")
                  : "",
            };
          }),
        solicitacaoValorVinculoList: this.listaValorCalculado,
      };
      this.$http
        .post(`${baseApiUrl}/despachos/indeferir`, JSON.stringify(bodyRequest))
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Despacho Indeferido com sucesso.",
            life: 3000,
          });
          this.voltarParaLista();
        });
    },
    enviarCriacao() {
      let id = this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc
        ? this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc
        : this.solicitacaoVerbaRec.idenSolicitacaoVerbaRescisoria;
      let bodyRequest = {
        statusAndamento: "EM_ANALISE",
      };
      this.$http
        .put(
          `${baseApiUrl}/solicitacoes-verba-rescisoria/status/${id}`,
          JSON.stringify(bodyRequest)
        )
        .then(() => {
          this.voltarParaLista();
        });
    },
    confirmarFinalizacao() {
      this.visualizarModalEnviarProsta = true;
    },
    confirmarIndeferimento() {
      this.visualizarModalIndeferir = true;
    },
    confirmarRevisao() {
      this.visualizarModalConfirmacaoRevisao = true;
    },
    fecharRevisao() {
      this.visualizarModalConfirmacaoRevisao = false;
    },
    enviarRevisao() {
      this.visualizarModalConfirmacaoRevisao = false;
      let id = this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc
        ? this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc
        : this.solicitacaoVerbaRec.idenSolicitacaoVerbaRescisoria;
      let bodyRequest = {
        statusAndamento: "EM_REVISAO",
      };
      this.$http
        .put(
          `${baseApiUrl}/solicitacoes-verba-rescisoria/status/${id}`,
          JSON.stringify(bodyRequest)
        )
        .then(() => {
          this.voltarParaLista();
        });
    },
    buscaMotivo(code) {
      let name = "";
      for (let i = 0; i < this.listaMotivo.length; i++) {
        if (this.listaMotivo[i].code == code) {
          name = this.listaMotivo[i].name;
          break;
        }
      }
      return name;
    },
    applyMask() {
      let value = this.processo.descProcesso.replace(/\D/g, ""); // Remove tudo que não é número
      if (
        value.length == 16 &&
        value[15] == 1 &&
        value[14] == 1 &&
        value[13] == 8
      ) {
        value = value.slice(0, 12);
      }
      // Aplica as partes da máscara manualmente
      if (
        value.length > 12 &&
        value[15] == 1 &&
        value[14] == 1 &&
        value[13] == 8
      ) {
        value =
          value.slice(0, 7) +
          "-" +
          value.slice(7, 9) +
          "." +
          value.slice(9, 13) +
          ".8.11." +
          value.slice(16, 20);
      } else if (value.length > 12) {
        value =
          value.slice(0, 7) +
          "-" +
          value.slice(7, 9) +
          "." +
          value.slice(9, 13) +
          ".8.11." +
          value.slice(13, 20);
      } else if (value.length > 9) {
        value =
          value.slice(0, 7) +
          "-" +
          value.slice(7, 9) +
          "." +
          value.slice(9, 13);
      } else if (value.length > 7) {
        value = value.slice(0, 7) + "-" + value.slice(7);
      }
      this.processo.descProcesso = value;
    },
    validarData() {
      // Expressão regular para validar o formato "DD/MM/YYYY"
      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

      if (regex.test(this.processo.dataCitacao)) {
        // Se passar no regex, validar a data real
        const partes = this.processo.dataCitacao.split("/");
        const dia = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10) - 1; // Meses no JavaScript são de 0 a 11
        const ano = parseInt(partes[2], 10);
        const dataHoje = new Date();
        if (ano < 1980) {
          return false;
        }
        const data = new Date(ano, mes, dia);
        if (data > dataHoje) {
          return false;
        }
        // Verifica se a data gerada é válida (correção automática do JS)
        return (
          data.getFullYear() === ano &&
          data.getMonth() === mes &&
          data.getDate() === dia
        );
      } else {
        return false;
      }
    },
    mascaraValor(campo) {
      // Acesse o valor diretamente do v-model usando o nome do campo
      let valor = this.valorselecionado[campo];
      // Remove qualquer caractere que não seja número, ponto ou sinal de menos
      valor = valor.replace(/[^0-9.,-]/g, "");
      // Se o valor for indefinido ou nulo, inicie como uma string vazia
      if (valor == null) {
        valor = "";
      }
      // Se o valor for apenas um "-", mantenha
      if (valor === "-") {
        return; // Retorna sem fazer nada
      }

      if (valor.indexOf(",") != -1) {
        valor = valor.replace(/,/g, ".");
      }

      // Garante que o sinal de menos apareça apenas no início
      if (valor[0] === "-") {
        valor = "-" + valor.slice(1).replace(/-/g, ""); // Remove outros sinais de menos
      } else {
        valor = valor.replace(/-/g, ""); // Se o "-" for colocado em outro lugar, remova
      }

      // Garante que apenas um ponto decimal seja permitido
      const partes = valor.split(".");
      if (partes.length > 2) {
        valor = partes[0] + "." + partes[1]; // Remove pontos decimais extras
      } else if (partes.length > 1 && partes[1].length > 2) {
        valor =
          partes[0] + "." + partes[1][0] + partes[1][partes[1].length - 1]; // Remove pontos decimais extras
      } else if (partes.length > 1 && partes[1] == "") {
        return;
      }

      // Atualiza o valor no v-model sem quebrar a digitação
      this.$set(this.valorselecionado, campo, valor ? Number(valor) : null);
    },
    mascaraValorEditaTadaFim(campo) {
      // Acesse o valor diretamente do v-model usando o nome do campo
      let valor = this.registroDataFinal[campo];
      // Remove qualquer caractere que não seja número, ponto ou sinal de menos
      valor = valor.replace(/[^0-9.,-]/g, "");
      // Se o valor for indefinido ou nulo, inicie como uma string vazia
      if (valor == null) {
        valor = "";
      }
      // Se o valor for apenas um "-", mantenha
      if (valor === "-") {
        return; // Retorna sem fazer nada
      }

      if (valor.indexOf(",") != -1) {
        valor = valor.replace(/,/g, ".");
      }
      // Garante que o sinal de menos apareça apenas no início
      if (valor[0] === "-") {
        valor = "-" + valor.slice(1).replace(/-/g, ""); // Remove outros sinais de menos
      } else {
        valor = valor.replace(/-/g, ""); // Se o "-" for colocado em outro lugar, remova
      }

      // Garante que apenas um ponto decimal seja permitido
      const partes = valor.split(".");
      if (partes.length > 2) {
        valor = partes[0] + "." + partes[1]; // Remove pontos decimais extras
      } else if (partes.length > 1 && partes[1].length > 2) {
        valor =
          partes[0] + "." + partes[1][0] + partes[1][partes[1].length - 1]; // Remove pontos decimais extras
      } else if (partes.length > 1 && partes[1] == "") {
        return;
      }

      // Atualiza o valor no v-model sem quebrar a digitação
      this.$set(this.registroDataFinal, campo, valor ? Number(valor) : 0);
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
.textoInformativoVerbaIdenizatoriaForm {
  line-height: 1.5;
  margin: 0;
  text-align: justify;
}
.iconIdentificacaoForm {
  font-size: 8em;
}
.divRadioButton {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.divBotoesFinais {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.p-dialog-content {
  overflow-y: hidden !important;
}
</style>
